import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface CreateOcrDocumentRequest {
  poId?: number | null;
  poNumber: string;
  invoiceNumber: string;
  companyId: number;
  supplierId: number;
  isOnlineSupplier: boolean;
}

export interface CreateOcrDocumentResponse {
  poId: string;
  invoiceId: string;
}

export interface CreateOcrDocumentParams {
  attachmentId: number;
  body: CreateOcrDocumentRequest;
}

const useCreateOcrDocumentApi = () => {
  const call = useCallback(async (params?: CreateOcrDocumentParams | undefined) => {
    if (!params?.body) return {} as CreateOcrDocumentResponse;
    const res = await axiosInstance.post<CreateOcrDocumentResponse>(
      api.createOcrDocument(params?.attachmentId as number),
      params.body
    );
    return res.data as CreateOcrDocumentResponse;
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return {
    createOcrDocument: execute,
    isCreateAndConfirmDocumentLoading: isLoading,
  };
};

export default useCreateOcrDocumentApi;
